import {Link} from '@ezcater/tapas/legacy';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

import appBarQr from '@/assets/apps-flyer/cta-qr-app-bar.svg';
import leftMenuNavQr from '@/assets/apps-flyer/cta-qr-left-nav.svg';
import {EzcaterLogo} from '@/components/ui';
import useEzRewardsEligibility from '@/hooks/useEzRewardsEligibility';
import useTracking from '@/hooks/useTracking';

type AppDownloadCTAProps = {
  location: 'app-bar' | 'left-menu-nav';
};

const AppDownloadCTA: React.FC<AppDownloadCTAProps> = ({location}) => {
  const {t} = useTranslation('common');
  const {trackClick} = useTracking();
  const {canAccessEzRewards} = useEzRewardsEligibility();
  const qrCode = (() => {
    switch (location) {
      case 'app-bar':
        return appBarQr;
      case 'left-menu-nav':
        return leftMenuNavQr;
    }
  })();
  const appLink = (() => {
    switch (location) {
      case 'app-bar':
        return 'https://ezcater.onelink.me/T4QA/d8jtnezw';
      case 'left-menu-nav':
        return 'https://ezcater.onelink.me/T4QA/ron3zlpv';
    }
  })();
  const onClick = () => {
    trackClick(`app-download-cta-in-${location}`);
  };

  return (
    <>
      <div className="hidden xl:block">
        <div className="flex max-w-72 items-center gap-3 rounded-lg bg-blueberry-50 py-2 pl-3 pr-4">
          <Image alt="" src={qrCode.src} width="72" height="72" />
          <div className="flex flex-col items-start gap-1 py-0.5">
            <Link
              target="_blank"
              className="text-sm font-bold leading-6 text-black hover:text-black active:text-black"
              href={appLink}
              onClick={onClick}
            >
              {t('components.AppDownloadCta.getApp')}
            </Link>
            <p className="text-xs font-normal leading-4 text-black">
              {canAccessEzRewards
                ? t('components.AppDownloadCta.downloadAppText')
                : t('components.AppDownloadCta.downloadAppTextNoRewards')}
            </p>
          </div>
        </div>
      </div>
      <div className="block xl:hidden">
        <div className="flex items-center gap-3 px-4 py-2">
          <div className="flex items-center justify-center rounded-md bg-green-700 p-1 text-white">
            <EzcaterLogo variant="symbol" width={12} height={12} fillClassName="fill-green-300" />
          </div>
          <Link
            href="https://ezcater.onelink.me/T4QA/7sd7rtk1"
            onClick={() => trackClick('app-download-cta-nav-mobile')}
            className="text-sm text-black hover:text-black hover:decoration-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('components.AppDownloadCta.downloadApp')}
          </Link>
        </div>
      </div>
    </>
  );
};

export default AppDownloadCTA;
